import { AlertPopupComponent } from './alert';
import { ConfirmPopupComponent } from './confirm';

export { AlertPopupComponent, ConfirmPopupComponent };



// WEBPACK FOOTER //
// ./src/components/layout/popup/index.tsx